const member_userList = {
  pagingYn: true,
  pageSize: 10,
};

const cnslt_aplyList_user = {
  pagingYn: true,
  pageSize: 10,
};

const cnslt_aplyList_exprt = {
  pagingYn: true,
  pageSize: 10,
};

const expertAuditList = {
  pagingYn: true,
  pageSize: 10,
};

const expertAnalyzeList = {
  pagingYn: true,
  pageSize: 10,
};

const analyzeReportWrite = {
  pagingYn: false,
};

const analyzeReportWriteDetail = {
  pagingYn: false,
};

const workerInfo = {
  pagingYn: true,
  pageSize: 10,
};

const taskInfo = {
  pagingYn: true,
  pageSize: 10,
};

export default function getGridOptions(id) {
  switch (id) {
    case 'member_userList':
      return member_userList;
    case 'cnslt_aplyList_user':
      return cnslt_aplyList_user;
    case 'cnslt_aplyList_exprt':
      return cnslt_aplyList_exprt;
    case 'expertAuditList':
      return expertAuditList;
    case 'expertAnalyzeList':
      return expertAnalyzeList;
    case 'workerInfo':
      return workerInfo;
    case 'taskInfo':
      return taskInfo;
  }

  /* 보고서 생성 영역으로 인하여 id 중복문제가 발생하여 수정 */
  if (id.startsWith('analyzeReportWriteDetail')) {
    return analyzeReportWriteDetail;
  } else if (id.startsWith('analyzeReportWrite')) {
    return analyzeReportWrite;
  }
}
